import React, { Fragment, Component } from "react"
/* Material */
import {
  Typography,
  Switch,
  Button,
  Tooltip,
  TextField,
  Hidden,
  IconButton,
} from "@material-ui/core"
import ToggleButton from "@material-ui/lab/ToggleButton"
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup"
import { withStyles } from "@material-ui/core/styles"
import EditIcon from "@material-ui/icons/Edit"
import BackspaceIcon from "@material-ui/icons/Backspace"
import SettingsBackupRestoreIcon from "@material-ui/icons/SettingsBackupRestore"
import DeleteIcon from "@material-ui/icons/Delete"

import update from "immutability-helper"
import classNames from "classnames"
import { connect } from "react-redux"
import { Route, Switch as RouterSwitch, withRouter } from "react-router-dom"
import Shoot from "./index"
import ShootBilling from "./pages/Billing/index"
import { getCurrentHost } from "../../utils/getHost"
import { compose } from "recompose"
import styles from "./styles"
/* internal components */
import CrewMamaAppBarComponent from "../../components/CrewmamaAppBar"
import TabBar from "../../components/TabBar/index"
import MainAppBar from "../../components/MainAppBar/index"
import AutoComplete from "../../components/AutoComplete"
import LoadingButton from "../../components/LoadingButton"
import { sendDeletedShootEmail } from "../../actions/crew"
/* actions */
import {
  updateShoot,
  deleteShoot,
  getShootbyId,
  getShootDetails,
  createShootGlue,
  deleteShootGlue,
  setRoleForCrew,
  toggleRoleDialog,
  toggleShootDialog,
  toggleChangeRepresentativeDialog,
  recallShoot,
} from "../../actions/shoots"
import { clearCrewFromChip, getCrew } from "../../actions/crew"
import moment from "../../../node_modules/moment/moment"
/* assets */
import crewmamaCrown from "../../assets/images/crewmama_crown.svg"
import { getEquipment, getRoles, getUsers } from "../../actions/misc"
import { getClientCompanies, getClientList } from "../../actions/clients"
import { head, isNil } from "lodash"
import { openSnackBar } from "../../actions/snack-bar"
import { refreshToken } from "../../actions/authentication"
import Context from "./context"
import ChangeRepresentativeDialog from "../../components/ChangeRepresentativeDialog/index"
import AddClientCompanyDialog from "../../components/AddClientCompanyDialog/index"
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord"
import { getDealMemoData } from "../../actions/billing"
import { billingNotification } from "../../utils/billingNotification"
import ChangeRepresentativeButton from "../../components/ChangeRepresentativeButton/index"
import copy from "copy-to-clipboard"
import LoadingOverlay from "react-loading-overlay"
const defaultState = {
  shoot: null,
  currentTab: 1,
  status: null,
  dirty: false,
  newShootName: "",
  savingShootName: false,
  popover: {
    anchor: null,
    func: () => "",
  },
  changeRepLoading: false,
  selectUser: () => "",
  currentUpdateRole: null,
}

const statusOptions = [
  // {
  //   id: 1,
  //   name: "Open",
  // },
  // {
  //   id: 2,
  //   name: "Booked",
  // },
  {
    id: 3,
    name: "Wrapped",
  },
  {
    id: 4,
    name: "Billed",
  },
  {
    id: 5,
    name: "Paid",
  },
]

class ShootWrapper extends Component {
  state = defaultState
  componentWillUnmount() {
    this.props.dispatch(clearCrewFromChip())
  }

  componentDidMount() {
    this.callComponentMount()
  }

  callComponentMount = () => {
    let shootId = window.location.pathname.match(/\d+/g).map(Number)
    this.props.users.length === 1 && this.props.dispatch(getUsers())
    this.props.roles.length === 1 && this.props.dispatch(getRoles())
    this.props.equipment.length === 1 && this.props.dispatch(getEquipment())
    this.props.companyList.length === 0 &&
      this.props.dispatch(getClientCompanies())
    this.props.clientList.length === 0 && this.props.dispatch(getClientList())

    this.props
      .dispatch(getShootDetails(shootId))
      .then(() => {
        this.state.shoot.roles.forEach(role => {
          if (role.user_id) {
            this.props.dispatch(getCrew(role.user_id))
          }
        })
        this.state.shoot.shoots.forEach(applicant => {
          if (applicant.id) {
            this.props.dispatch(getCrew(applicant.user_id))
          }
        })
      })
      .catch(error => console.log("error", error))

    this.props.dispatch(getDealMemoData(shootId))
    this.props.dispatch(recallShoot(false))
  }

  callComponentUpdate = () => {
    if (!this.state.shoot && this.props.shoots.length > 0) {
      const shoot = this.props.shoots.find(
        x => x.id === Number(this.props.location.pathname.match(/(\d+)/g)[0])
      )
      // debugger;
      // fix start and end date
      if (shoot) {
        shoot.start_date =
          shoot && shoot.start_date && new Date(shoot.start_date)
        shoot.end_date = shoot && shoot.end_date && new Date(shoot.end_date)

        // fix call time
        // Need to add check to make sure it's in the right format 00:00:00
        const time = isNil(shoot.call_time) ? null : shoot.call_time.split(":")
        if (!isNil(time)) {
          shoot.call_time = new Date()
          shoot.call_time.setHours(time[0])
          shoot.call_time.setMinutes(time[1])
        }

        // update shoot date
        shoot.remove_equipment = []
        this.setState({ shoot })
        this.setState({
          newShootName: shoot.name,
        })
      }
    }

    if (
      this.state.shoot &&
      // this.state.shoot.client_id &&
      this.props.users &&
      this.props.users.length > 1
      // !this.state.shoot.client
    ) {
      let isAd = false
      this.props.authenticatedUser.companies.map(company => {
        if (company.name === "Assignment Desk") {
          company.managers.map(manager => {
            if (manager.id === this.props.authenticatedUser.id) {
              isAd = true
            }
          })
        }
      })
      let isRole = false
      this.state.shoot.roles.map(role => {
        if (role.user_id === this.props.authenticatedUser.id) {
          isRole = true
        }
      })
      // ONLY SHOOT OWNERS AND AD MEMBERS SHOULD BE ABLE TO VIEW THE EDIT SHOOT PAGES
      // Crew members should be redirected to the public shoot details page
      // There is already logic to direct crew members to the details page but this is just
      // in case they type the URL directly
      if (
        this.state.shoot.creator_id !== this.props.authenticatedUser.id &&
        isAd === false &&
        isRole === false
      ) {
        this.props.history.push(`/crew`)
      } else if (isRole && isAd === false) {
        // this.props.history.push(`/public/shoots/${this.state.shoot.id}`)
        this.props.history.push(`/my-shoots/${this.state.shoot.id}/details`)
      } else {
        // console.log("You are allowed to view this shoot")
      }
      const shootData = {}
      if (this.state.shoot.client_id && !this.state.shoot.client) {
        const client = this.props.users.find(
          x => x.id === this.state.shoot.client_id
        )
        if (client) {
          shootData.client = {
            $set: client,
          }
        }
      }

      if (Object.keys(shootData).length > 0) {
        this.setState(
          update(this.state, {
            shoot: shootData,
          })
        )
      }
    }
  }

  componentDidUpdate(p) {
    this.callComponentUpdate()
  }

  recallShooOnEffect = () => {}

  componentWillReceiveProps(nextProps) {
    if (nextProps.recall) {
      let shootId = window.location.pathname.match(/\d+/g).map(Number)
      this.props.dispatch(getShootbyId(shootId)).then(res => {
        let shoot = res.find(item => item.id === shootId[0])
        this.setState({ shoot })
        this.callComponentMount()
        this.callComponentUpdate()
      })
    }
  }

  save = () => {
    const { state, props } = this
    const { shoot } = state

    // check for authenticated user first

    // this.props.dispatch(hiddenLoginModal())

    //if user is not authenticated prompt the user to login first and save all the notes

    // the fine logic
    const clientId = props.createdClient
      ? props.createdClient.id
      : shoot.client_id
    const producerId = props.createdProducer
      ? props.createdProducer.id
      : shoot.producer
    let newShoot = { ...shoot, client_id: clientId, producer: producerId }
    const handleError = err => {
      this.props.dispatch(
        openSnackBar({
          message: "There was an error saving the shoot details",
        })
      )
      this.setState({ working: false })
    }

    newShoot.location = JSON.stringify(newShoot.location)
    this.setState({ working: true })
    this.saveEquipment()
      .then(res => {
        if (typeof newShoot.producer === "object" && newShoot.producer) {
          newShoot.producer = newShoot.producer.id
          this.props.dispatch(
            createShootGlue(shoot.id, "roles", {
              available: true,
              client_rate: 0,
              crew_rate: 0,
              role_id: 11,
              name: "PRODUCER",
              requested: true,
              user_id: newShoot.producer,
            })
          )
        }

        if (typeof newShoot.start_date !== "string") {
          newShoot.start_date = new Date(
            newShoot.start_date.toLocaleDateString("en-US")
          )
        }

        if (typeof newShoot.end_date !== "string") {
          newShoot.end_date = new Date(
            newShoot.end_date.toLocaleDateString("en-US")
          )
        }
        props
          .dispatch(refreshToken())
          .then(e => {
            props
              .dispatch(
                updateShoot(newShoot.id, { ...newShoot, client_id: clientId })
              )
              .then(e => {
                this.props.dispatch(
                  openSnackBar({ message: "Shoot details saved" })
                )
                this.setState({ working: false, dirty: false })
                return true
              })
              .catch(handleError)
          })
          .catch(handleError)
      })
      .catch(handleError)
  }

  saveEquipment = () => {
    const { props } = this
    const shoot = JSON.parse(JSON.stringify(this.state.shoot))
    return new Promise((resolve, reject) => {
      const newEquipment = shoot.equipment.filter(x => !x.equipment_id)
      const removeEquipment =
        shoot.remove_equipment && shoot.remove_equipment.length > 0
          ? shoot.remove_equipment.filter(x => x.equipment_id)
          : []
      const arr = removeEquipment
        .map(x =>
          // remove equipment
          {
            return props.dispatch(deleteShootGlue(shoot.id, x.id, "equipment"))
          }
        )
        .concat(
          newEquipment.map(x => {
            // add new equipment
            x.equipment_id = x.id
            delete x.id
            delete x.description
            delete x.name
            return props.dispatch(createShootGlue(shoot.id, "equipment", x))
          })
        )

      if (arr.length > 0) {
        return resolve(Promise.all(arr))
      } else {
        return resolve([])
      }
    })
  }

  saveShootName = () => {
    this.setState({
      savingShootName: true,
    })
    this.props
      .dispatch(
        updateShoot(this.state.shoot.id, {
          name: this.state.newShootName,
        })
      )
      .then(() => {
        this.setState(
          update(this.state, {
            shoot: {
              name: {
                $set: this.state.newShootName,
              },
            },
            // newShootName: {
            //   $set: "",
            // },
            savingShootName: {
              $set: false,
            },
            isEditingName: {
              $set: false,
            },
          })
        )
      })
  }

  //to be done for the crew members

  openDialog = (shootId, dialog) => {
    this.props.dispatch(clearCrewFromChip())
    this.props.dispatch(setRoleForCrew())
    if (dialog === "role") {
      this.props.dispatch(toggleRoleDialog({ open: true, id: shootId }))
    } else if (dialog === "crew-member") {
      let roleData = {
        role_id: 3788,
        name: "CREW MEMBER",
        shoot_id: shootId,
        expenses: [],
      }
      this.props.dispatch(setRoleForCrew(roleData))
      this.props.dispatch(
        toggleShootDialog({ open: true, id: shootId, crewMember: true })
      )
    } else {
      this.props.dispatch(toggleShootDialog({ open: true, id: shootId }))
    }
  }

  saveAndOpenDialog = (shootId, dialog) => {
    const { state, props } = this
    const { shoot } = state
    const clientId = props.createdClient
      ? props.createdClient.id
      : shoot.client_id
    const producerId = props.createdProducer
      ? props.createdProducer.id
      : shoot.producer
    let newShoot = { ...shoot, client_id: clientId, producer: producerId }
    const handleError = err => {
      this.props.dispatch(
        openSnackBar({
          message: "There was an error saving the shoot details",
        })
      )
      this.setState({ working: false })
      this.props.dispatch(clearCrewFromChip())
      this.props.dispatch(setRoleForCrew())
      if (dialog === "role") {
        this.props.dispatch(toggleRoleDialog({ open: true, id: shootId }))
      } else {
        this.props.dispatch(toggleShootDialog({ open: true, id: shootId }))
      }
    }
    newShoot.location = JSON.stringify(newShoot.location)
    this.setState({ working: true })
    this.saveEquipment()
      .then(res => {
        if (typeof newShoot.producer === "object" && newShoot.producer) {
          newShoot.producer = newShoot.producer.id
          this.props.dispatch(
            createShootGlue(shoot.id, "roles", {
              available: true,
              client_rate: 0,
              crew_rate: 0,
              role_id: 11,
              name: "PRODUCER",
              requested: true,
              user_id: newShoot.producer,
            })
          )
        }

        if (typeof newShoot.start_date !== "string") {
          newShoot.start_date = new Date(
            newShoot.start_date.toLocaleDateString("en-US")
          )
        }

        if (typeof newShoot.end_date !== "string") {
          newShoot.end_date = new Date(
            newShoot.end_date.toLocaleDateString("en-US")
          )
        }
        props
          .dispatch(
            updateShoot(newShoot.id, { ...newShoot, client_id: clientId })
          )
          .then(e => {
            this.props.dispatch(
              openSnackBar({ message: "Shoot details saved" })
            )
            this.setState({ working: false, dirty: false })
            this.props.dispatch(clearCrewFromChip())
            this.props.dispatch(setRoleForCrew())
            if (dialog === "role") {
              this.props.dispatch(toggleRoleDialog({ open: true, id: shootId }))
            } else {
              this.props.dispatch(
                toggleShootDialog({ open: true, id: shootId })
              )
            }
            return true
          })
          .catch(handleError)
      })
      .catch(handleError)
  }

  changeShootStatus = e => {
    //this doesnt seem to be working
    const { shoot } = this.state
    let canCancel = false
    if (shoot && shoot.status) {
      canCancel = shoot.status !== "cancelled"
    }
    this.setState({
      popover: {
        func: e => {
          if (e) {
            const newStatus = canCancel ? "cancelled" : null
            this.setState({
              status: newStatus,
            })
            this.props
              .dispatch(
                updateShoot(shoot.id, {
                  status: newStatus,
                })
              )
              .then(res => {
                let shootId = window.location.pathname.match(/\d+/g).map(Number)
                this.props.dispatch(getShootbyId(shootId))
                window.location.href = window.location.pathname
              })
          }
        },
        anchor: e.currentTarget,
      },
    })
  }

  saveAndUpdateStatus = e => {
    const { state, props } = this
    const { shoot } = state
    let canCancel = false
    if (shoot && shoot.status) {
      canCancel = shoot.status !== "cancelled"
    }
    const clientId = props.createdClient
      ? props.createdClient.id
      : shoot.client_id
    const producerId = props.createdProducer
      ? props.createdProducer.id
      : shoot.producer
    let newShoot = { ...shoot, client_id: clientId, producer: producerId }
    const handleError = err => {
      this.props.dispatch(
        openSnackBar({
          message: "There was an error saving the shoot details",
        })
      )
      this.setState({ working: false })
      this.changeShootStatus(e)
    }
    newShoot.location = JSON.stringify(newShoot.location)
    this.setState({ working: true })
    this.saveEquipment()
      .then(res => {
        if (typeof newShoot.producer === "object" && newShoot.producer) {
          newShoot.producer = newShoot.producer.id
          this.props.dispatch(
            createShootGlue(shoot.id, "roles", {
              available: true,
              client_rate: 0,
              crew_rate: 0,
              role_id: 11,
              name: "PRODUCER",
              requested: true,
              user_id: newShoot.producer,
            })
          )
        }

        if (typeof newShoot.start_date !== "string") {
          newShoot.start_date = new Date(
            newShoot.start_date.toLocaleDateString("en-US")
          )
        }

        if (typeof newShoot.end_date !== "string") {
          newShoot.end_date = new Date(
            newShoot.end_date.toLocaleDateString("en-US")
          )
        }
        props
          .dispatch(
            updateShoot(newShoot.id, { ...newShoot, client_id: clientId })
          )
          .then(e => {
            this.props.dispatch(
              openSnackBar({ message: "Shoot details saved" })
            )
            this.setState({
              working: false,
              dirty: false,
              popover: {
                func: e => {
                  if (e) {
                    const newStatus = canCancel ? "cancelled" : null
                    this.setState({
                      status: newStatus,
                    })
                    this.props
                      .dispatch(
                        updateShoot(shoot.id, {
                          status: newStatus,
                        })
                      )
                      .then(res => {
                        let shootId = window.location.pathname
                          .match(/\d+/g)
                          .map(Number)
                        this.props.dispatch(getShootbyId(shootId))
                        window.location.href = window.location.pathname
                      })
                  }
                },
                anchor: e.currentTarget,
              },
            })
            return true
          })
          .catch(handleError)
      })
      .catch(handleError)
  }

  openRepresentativeDialog = bool => {
    this.props.dispatch(toggleChangeRepresentativeDialog(bool))
  }

  handleChangePage = (_event, newValue) => {
    let url =
      this.props.match.url.substr(-1) === "/"
        ? this.props.match.url.slice(0, -1)
        : this.props.match.url
    this.props.history.push(url + (newValue ? newValue : ""))
  }

  copyToClipBoard = () => {
    let shoot = window.location.pathname
    if (window.location.pathname.includes("billing")) {
      shoot = shoot.split("billing")[0]
    }
    let shootPublicLink = `${window.location.origin}/public${shoot}`

    copy(shootPublicLink)
  }

  render() {
    const { props, state } = this
    const {
      classes,
      activeCompany,
      authenticatedUser,
      history,
      dispatch,
      setState,
      changeRepresentativeDialogOpen,
      crew,
      generalData,
    } = props
    const { shoot, dirty, working, popover } = state

    const currentLocation = history.location.pathname.replace(
      props.match.url,
      ""
    )

    const onChangeActiveRepresentative = async name => {
      const { shoot } = this.state

      await this.setState({ working: true, changeRepLoading: true })

      this.props
        .dispatch(
          updateShoot(shoot.id, {
            representative: name,
          })
        )
        .then(() => {
          let shootId = window.location.pathname.match(/\d+/g).map(Number)

          this.props.dispatch(getShootbyId(shootId)).then(res => {
            const shoot = res.find(item => item.id === shootId[0])
            this.callComponentMount()
            this.setState({ shoot })
            this.setState({ changeRepLoading: false })

            this.props.dispatch(toggleChangeRepresentativeDialog(false))
          })
        })

      this.setState({ working: false })
    }

    let canCancel = false
    if (shoot && shoot.status) {
      canCancel = shoot.status !== "cancelled"
    }

    let isAd = false
    this.props.authenticatedUser.companies.map(company => {
      if (company.name === "Assignment Desk") {
        company.managers.map(manager => {
          if (manager.id === this.props.authenticatedUser.id) {
            isAd = true
          }
        })
      }
    })
    // Making sure only shoot owners and AD users have deletetion privileges
    let canDelete = false
    if (shoot && shoot.roles) {
      if (this.state.shoot.creator_id !== this.props.authenticatedUser.id) {
        if (isAd === false) {
          canDelete = false
        } else if (shoot.roles.length === 0) {
          canDelete = true
        } else {
          canDelete = false
        }
      } else if (shoot.roles.length === 0) {
        canDelete = true
      } else {
        canDelete = false
      }
    }

    // let canDelete = false
    // if (shoot && shoot.roles) {
    //   canDelete =
    //     shoot.roles.length === 0 &&
    //     (shoot.creator_id === authenticatedUser.id ||
    //       (activeCompany !== null && activeCompany === shoot.company_id))
    // }

    return (
      <Context.Provider
        value={{
          ...this.state,
          crew,
          authenticatedUser,
          dispatch: this.props.dispatch,
          equipment: this.props.equipment,
          users: this.props.users,
        }}
      >
        <LoadingOverlay active={working} spinner text="Saving Shoot Details...">
          {getCurrentHost() === "crewmama" ? (
            <CrewMamaAppBarComponent history={history} />
          ) : (
            <Fragment>
              <MainAppBar />
              <TabBar history={history} />
            </Fragment>
          )}
          {shoot && (
            <Fragment>
              {/* WEB VIEW */}
              <Hidden smDown>
                <div
                  style={{
                    padding: "32px",
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#f8f8f8",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <Fragment>
                      <Button
                        color="primary"
                        variant="contained"
                        onClick={e =>
                          dirty
                            ? this.saveAndOpenDialog(shoot.id, "role")
                            : this.openDialog(shoot.id, "role")
                        }
                      >
                        +Add Role
                      </Button>
                      <Button
                        color="primary"
                        variant="contained"
                        style={{ marginLeft: "10px" }}
                        onClick={e =>
                          dirty
                            ? this.saveAndOpenDialog(shoot.id, "crew")
                            : this.openDialog(shoot.id, "crew")
                        }
                      >
                        +Add Crew
                      </Button>
                      <Button
                        color="primary"
                        variant="contained"
                        style={{ marginLeft: "10px" }}
                        onClick={e =>
                          dirty
                            ? this.saveAndOpenDialog(shoot.id, "crew-member")
                            : this.openDialog(shoot.id, "crew-member")
                        }
                      >
                        +Add Crew Member
                      </Button>

                      <Button
                        color="primary"
                        variant="contained"
                        style={{ marginLeft: "10px" }}
                        onClick={this.copyToClipBoard}
                      >
                        Copy Shoot Link
                      </Button>
                    </Fragment>
                  </div>

                  <div style={{ display: "flex" }}>
                    {/* publish/unPublish section */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: "64px",
                      }}
                    >
                      <Typography
                        className={classNames("", {
                          [classes.selected]: !shoot.published,
                          [classes.unselected]: shoot.published,
                        })}
                      >
                        Unpublish
                      </Typography>
                      <Switch
                        color="primary"
                        checked={Boolean(shoot.published)}
                        onChange={e => {
                          this.setState(
                            update(state, {
                              shoot: {
                                published: {
                                  $set: !shoot.published,
                                },
                              },
                            })
                          )
                          dispatch(
                            updateShoot(shoot.id, {
                              published: !shoot.published,
                            })
                          )
                        }}
                      />
                      <Typography
                        className={classNames("", {
                          [classes.selected]: shoot.published,
                          [classes.unselected]: !shoot.published,
                        })}
                      >
                        Publish
                      </Typography>
                    </div>

                    {/* standby/firm section */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: "64px",
                      }}
                    >
                      <Typography
                        className={classNames("", {
                          [classes.selected]: !shoot.firm,
                          [classes.unselected]: shoot.firm,
                        })}
                      >
                        Standby
                      </Typography>
                      <Switch
                        color="primary"
                        checked={Boolean(shoot.firm)}
                        onChange={e => {
                          // update locally
                          this.setState(
                            update(state, {
                              shoot: {
                                firm: {
                                  $set: !shoot.firm,
                                },
                              },
                            })
                          )
                          // update in api
                          dispatch(updateShoot(shoot.id, { firm: !shoot.firm }))
                        }}
                      />
                      <Typography
                        className={classNames("", {
                          [classes.selected]: shoot.firm,
                          [classes.unselected]: !shoot.firm,
                        })}
                      >
                        Firm
                      </Typography>
                    </div>
                    {/* end standby/firm section */}

                    {/* start day dection */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: "64px",
                      }}
                    >
                      <Typography
                        className={classNames("", {
                          [classes.selected]: !shoot.full_day,
                          [classes.unselected]: shoot.full_day,
                        })}
                      >
                        Half Day
                      </Typography>
                      <Switch
                        color="primary"
                        checked={Boolean(shoot.full_day)}
                        onChange={e => {
                          // update locally
                          this.setState(
                            update(state, {
                              shoot: {
                                full_day: {
                                  $set: !shoot.full_day,
                                },
                              },
                            })
                          )
                          // update in api
                          dispatch(
                            updateShoot(shoot.id, {
                              full_day: !shoot.full_day,
                            })
                          )
                        }}
                      />
                      <Typography
                        className={classNames("", {
                          [classes.selected]: shoot.full_day,
                          [classes.unselected]: !shoot.full_day,
                        })}
                      >
                        Full Day
                      </Typography>
                    </div>
                    {/* end day section */}
                    {/* status section */}
                    {/* <div style={{ marginLeft: "32px", zIndex: 3 }}>
                    {shoot.status === "open" ||
                    shoot.status === "booked" ||
                    shoot.status === "cancelled" ? (
                      <Typography variant="h6">
                        Status: {shoot.status}
                      </Typography>
                    ) : (
                      <AutoComplete
                        value={
                          !this.state.status
                            ? statusOptions.find(
                                x =>
                                  shoot.status &&
                                  shoot.status.toLowerCase &&
                                  x.name.toLowerCase() ===
                                    shoot.status.toLowerCase()
                              )
                            : this.state.status
                        }
                        showValue
                        placeholder="Status"
                        onChange={id => {
                          this.setState({
                            status: statusOptions.find(x => x.id === id),
                          })
                          dispatch(
                            updateShoot(shoot.id, {
                              status: statusOptions
                                .find(x => x.id === id)
                                .name.toLowerCase(),
                            })
                          )
                        }}
                        defaultOptions={statusOptions}
                        labelKey="name"
                        openMenuOnClick={true}
                      />
                    )}
                  </div> */}

                    <div style={{ marginLeft: "32px", zIndex: 3 }}>
                      {shoot.status && (
                        <Typography variant="h6">
                          Status: {shoot.status}
                        </Typography>
                      )}
                    </div>

                    {/* end status section */}
                  </div>
                </div>
              </Hidden>
              {/* MOBILE VIEW */}
              <Hidden mdUp>
                {currentLocation.indexOf("/billing") > -1 && (
                  <div
                    style={{
                      display: "flex",
                      padding: "10px",
                    }}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      size="small"
                      onClick={e =>
                        dirty
                          ? this.saveAndOpenDialog(shoot.id, "role")
                          : this.openDialog(shoot.id, "role")
                      }
                    >
                      +Add Role
                    </Button>
                    <Button
                      color="primary"
                      variant="contained"
                      style={{ marginLeft: "10px" }}
                      onClick={e =>
                        dirty
                          ? this.saveAndOpenDialog(shoot.id, "crew")
                          : this.openDialog(shoot.id, "crew")
                      }
                    >
                      +Add Crew
                    </Button>
                    <Button
                      color="primary"
                      variant="contained"
                      size="small"
                      style={{ marginLeft: "10px" }}
                      onClick={e =>
                        dirty
                          ? this.saveAndOpenDialog(shoot.id, "crew-member")
                          : this.openDialog(shoot.id, "crew-member")
                      }
                    >
                      +Add Crew Member
                    </Button>
                  </div>
                )}

                <div
                  style={{
                    margin: "18px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {/* shoot name */}
                  {!this.state.isEditingName && (
                    <Typography
                      onClick={e =>
                        this.setState({
                          isEditingName: true,
                        })
                      }
                      variant="h5"
                      className={classes.shootName}
                    >
                      {shoot.name}
                      <EditIcon className={classes.editIcon} />
                    </Typography>
                  )}
                  {this.state.isEditingName && (
                    <Fragment>
                      <TextField
                        label="Shoot Name"
                        value={this.state.newShootName}
                        onChange={e =>
                          this.setState({ newShootName: e.target.value })
                        }
                        className={classes.editNameTextField}
                      />
                      <LoadingButton
                        color="secondary"
                        buttonclicked={this.saveShootName}
                        working={this.state.savingShootName}
                        type="button"
                      >
                        Save
                      </LoadingButton>
                    </Fragment>
                  )}

                  {activeCompany &&
                    shoot.source &&
                    shoot.source === "crewmama" && (
                      <div style={{ marginTop: 10, marginBottom: 10 }}>
                        <ChangeRepresentativeButton
                          repName={
                            shoot.repsentative_name === null
                              ? shoot.creator_name
                              : shoot.repsentative_name
                          }
                          onClickFn={() => this.openRepresentativeDialog(true)}
                        />
                      </div>
                    )}
                  {/* end shoot name */}

                  {/* status section */}
                  <div style={{ marginTop: 10, marginBottom: 10, zIndex: 3 }}>
                    {shoot.status === "open" || shoot.status === "booked" ? (
                      <Typography variant="h6">
                        Status: {shoot.status}
                      </Typography>
                    ) : (
                      <AutoComplete
                        value={
                          !this.state.status
                            ? statusOptions.find(
                                x =>
                                  shoot.status &&
                                  shoot.status.toLowerCase &&
                                  x.name.toLowerCase() ===
                                    shoot.status.toLowerCase()
                              )
                            : this.state.status
                        }
                        showValue
                        placeholder="Status"
                        onChange={id => {
                          this.setState({
                            status: statusOptions.find(x => x.id === id),
                          })
                          dispatch(
                            updateShoot(shoot.id, {
                              status: statusOptions
                                .find(x => x.id === id)
                                .name.toLowerCase(),
                            })
                          )
                        }}
                        defaultOptions={statusOptions}
                        labelKey="name"
                        openMenuOnClick={true}
                      />
                    )}
                  </div>
                  {/* end status section */}

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: 10,
                    }}
                  >
                    {/* start day dection */}
                    <Typography
                      style={{ width: 70 }}
                      className={classNames("", {
                        [classes.selected]: !shoot.full_day,
                        [classes.unselected]: shoot.full_day,
                      })}
                    >
                      Half Day
                    </Typography>
                    <Switch
                      color="primary"
                      checked={Boolean(shoot.full_day)}
                      onChange={e => {
                        // update locally
                        this.setState(
                          update(state, {
                            shoot: {
                              full_day: {
                                $set: !shoot.full_day,
                              },
                            },
                          })
                        )
                        // update in api
                        dispatch(
                          updateShoot(shoot.id, { full_day: !shoot.full_day })
                        )
                      }}
                    />
                    <Typography
                      style={{ width: 70 }}
                      className={classNames("", {
                        [classes.selected]: shoot.full_day,
                        [classes.unselected]: !shoot.full_day,
                      })}
                    >
                      Full Day
                    </Typography>
                    {/* end day section */}
                    {/* standby/firm section */}
                    <Typography
                      style={{ width: 70 }}
                      className={classNames("", {
                        [classes.selected]: !shoot.firm,
                        [classes.unselected]: shoot.firm,
                      })}
                    >
                      Standby
                    </Typography>
                    <Switch
                      color="primary"
                      checked={Boolean(shoot.firm)}
                      onChange={e => {
                        // update locally
                        this.setState(
                          update(state, {
                            shoot: {
                              firm: {
                                $set: !shoot.firm,
                              },
                            },
                          })
                        )
                        // update in api
                        dispatch(updateShoot(shoot.id, { firm: !shoot.firm }))
                      }}
                    />
                    <Typography
                      style={{ width: 70 }}
                      className={classNames("", {
                        [classes.selected]: shoot.firm,
                        [classes.unselected]: !shoot.firm,
                      })}
                    >
                      Firm
                    </Typography>
                    {/* end standby/firm section */}
                  </div>
                </div>
                <ToggleButtonGroup
                  value={currentLocation}
                  exclusive
                  onChange={this.handleChangePage}
                  aria-label="text alignment"
                  className={classes.buttonGroup}
                  style={{ marginBottom: "15px" }}
                >
                  <ToggleButton value="" color="primary" aria-label="details">
                    Details
                  </ToggleButton>
                  <ToggleButton
                    value="/billing"
                    color="primary"
                    selected={currentLocation.indexOf("/billing") > -1}
                    aria-label="billing"
                  >
                    Billing
                    {billingNotification(this.props.usersRolesArray) ? (
                      <FiberManualRecordIcon
                        style={{
                          color: "#F04031",
                          position: "absolute",
                          fonstSize: "13px",
                          top: "-8",
                          right: "-6",
                        }}
                      />
                    ) : null}
                  </ToggleButton>
                </ToggleButtonGroup>
              </Hidden>
            </Fragment>
          )}
          {/* end top shoot section */}

          {/* Start Shoot Action Bar */}
          {/* WEB VIEW */}
          <Hidden smDown>
            {shoot && (
              <div
                style={{
                  display: "flex",
                  flexGrow: 1,
                  paddingRight: "30px",
                  paddingLeft: "30px",
                  backgroundColor: "#f8f8f8",
                }}
              >
                <div
                  style={
                    this.state.isEditingName
                      ? {
                          flexGrow: 1,
                          display: "flex",
                          alignItems: "center",
                        }
                      : null
                  }
                >
                  {/* shoot name */}
                  {!this.state.isEditingName && (
                    <Typography
                      onClick={e =>
                        this.setState({
                          isEditingName: true,
                        })
                      }
                      variant="h5"
                      className={classes.shootName}
                    >
                      {shoot.name}
                      <EditIcon className={classes.editIcon} />
                    </Typography>
                  )}
                  {this.state.isEditingName && (
                    <Fragment>
                      <TextField
                        label="Shoot Name"
                        value={this.state.newShootName}
                        onChange={e =>
                          this.setState({ newShootName: e.target.value })
                        }
                        className={classes.editNameTextFieldWeb}
                      />
                      <LoadingButton
                        color="secondary"
                        buttonclicked={this.saveShootName}
                        working={this.state.savingShootName}
                        type="button"
                      >
                        Save
                      </LoadingButton>
                    </Fragment>
                  )}
                  {/* end shoot name */}
                </div>
                <div
                  style={{
                    flexGrow: 1,
                    flexShrink: 1,
                  }}
                />
                {/* start representtive section */}
                {/* <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "64px",
                }}
              > */}
                {activeCompany &&
                  shoot.source &&
                  shoot.source === "crewmama" && (
                    <div style={{ alignSelf: "center" }}>
                      <ChangeRepresentativeButton
                        repName={
                          shoot.repsentative_name === null
                            ? shoot.creator_name
                            : shoot.repsentative_name
                        }
                        onClickFn={() => this.openRepresentativeDialog(true)}
                      />
                    </div>
                  )}
                {/* </div> */}
                {/* end representtive section */}
                <div
                  style={{
                    flexGrow: 1,
                    flexShrink: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    alignSelf: "flex-end",
                  }}
                >
                  <ToggleButtonGroup
                    value={currentLocation}
                    exclusive
                    onChange={this.handleChangePage}
                    aria-label="text alignment"
                    className={classes.buttonGroup}
                  >
                    <ToggleButton value="" color="primary" aria-label="details">
                      Details
                    </ToggleButton>
                    <ToggleButton
                      value="/billing"
                      color="primary"
                      selected={currentLocation.indexOf("/billing") > -1}
                      aria-label="billing"
                    >
                      Billing
                      {billingNotification(this.props.usersRolesArray) ? (
                        <FiberManualRecordIcon
                          style={{
                            color: "#F04031",
                            position: "absolute",
                            fonstSize: "13px",
                            top: "-8",
                            right: "-6",
                          }}
                        />
                      ) : null}
                    </ToggleButton>
                  </ToggleButtonGroup>
                  <Tooltip
                    placement="top"
                    title={
                      !shoot ||
                      (shoot &&
                        shoot.roles.filter(x => x.available === 1).length > 0)
                        ? "mark all crew as not available"
                        : canCancel
                          ? "this will cancel the shoot"
                          : "this will restore the shoot"
                    }
                  >
                    <div>
                      <IconButton
                        disabled={
                          !shoot ||
                          (shoot &&
                            shoot.roles.filter(x => x.available === 1).length >
                              0)
                        }
                        onClick={e => {
                          dirty
                            ? this.saveAndUpdateStatus(e)
                            : this.changeShootStatus(e)
                        }}
                        style={{ marginRight: "16px" }}
                      >
                        {canCancel || !shoot ? (
                          <BackspaceIcon
                            className={
                              canCancel || !shoot ? classes.iconButton : {}
                            }
                          />
                        ) : (
                          <SettingsBackupRestoreIcon
                            className={
                              !canCancel || shoot ? classes.iconButton : {}
                            }
                          />
                        )}
                      </IconButton>
                    </div>
                  </Tooltip>
                  <Tooltip
                    placement="top"
                    title={
                      canDelete
                        ? "this will delete the shoot forever"
                        : shoot && shoot.roles && shoot.roles.length === 0
                          ? "you do not have enough access to remove this shoot"
                          : "remove all positions from the shoot first"
                    }
                  >
                    <div>
                      <IconButton
                        disabled={!canDelete}
                        onClick={e => {
                          this.setState({
                            popover: {
                              func: e =>
                                e
                                  ? dispatch(deleteShoot(shoot.id))
                                      .then(res => {
                                        if (this.props.activeCompany) {
                                          this.props.history.push("/shoots")
                                        } else {
                                          this.props.history.push("/my-shoots")
                                        }
                                      })
                                      .then(res => {
                                        dispatch(
                                          sendDeletedShootEmail({
                                            subject: "test",
                                            to: "test",
                                            message: `The shoot ${
                                              shoot.name
                                            } with ID ${
                                              shoot.id
                                            } has been deleted. You can view its data in the deleted_shoots table. 
                                          The shoot was deleted by ${
                                            this.props.authenticatedUser
                                              .first_name
                                          } ${
                                              this.props.authenticatedUser
                                                .last_name
                                            }, with a user ID of ${
                                              this.props.authenticatedUser.id
                                            }`,
                                          })
                                        )
                                      })
                                  : "",
                              anchor: e.currentTarget,
                            },
                          })
                        }}
                        style={{ marginRight: "16px" }}
                      >
                        <DeleteIcon className={classes.iconButton} />
                      </IconButton>
                    </div>
                  </Tooltip>
                </div>
              </div>
            )}
          </Hidden>
          {/* End Shoot Action Bar */}
          <RouterSwitch>
            <Route exact path={props.match.path} props={props}>
              <Shoot
                shoot={shoot}
                dirty={dirty}
                working={working}
                popover={popover}
                state={state}
                setState={state => this.setState(state)}
                save={() => this.save}
                saveAndOpenDialog={() => this.saveAndOpenDialog}
                openDialog={() => this.openDialog}
                // openRepresentativeDialog={() => this.openRepresentativeDialog}
                onChangeActiveRepresentative={name =>
                  this.onChangeActiveRepresentative(name)
                }
                getShoot={shoot => {
                  this.callComponentMount()
                  this.setState({ shoot })
                }}
              />
            </Route>
            <Route
              path={`${props.match.path}/billing`}
              component={ShootBilling}
              props={props}
            />
          </RouterSwitch>

          {shoot &&
            activeCompany && (
              <ChangeRepresentativeDialog
                onClose={() =>
                  dispatch(toggleChangeRepresentativeDialog(false))
                }
                open={changeRepresentativeDialogOpen}
                activeManager={
                  shoot.representative ? shoot.representative : "Robin Morton"
                }
                creators={
                  authenticatedUser.companies.find(x => x.id === activeCompany)
                    ? authenticatedUser.companies.find(
                        x => x.id === activeCompany
                      ).managers
                    : []
                }
                loading={this.state.changeRepLoading}
                changeActiveRepresentative={name =>
                  onChangeActiveRepresentative(name)
                }
              />
            )}
          {shoot &&
            activeCompany && (
              <AddClientCompanyDialog
                origin="create_shoot"
                onSaveUser={res => {
                  setState(
                    update(this.props.state, {
                      shoot: {
                        client_company: {
                          $set: res.id,
                        },
                      },
                      dirty: {
                        $set: true,
                      },
                    })
                  )
                }}
              />
            )}
        </LoadingOverlay>
      </Context.Provider>
    )
  }
}
const mapStateToProps = state => {
  return {
    generalData: state.billing.generalData,
    usersRolesArray: state.billing.usersRolesArray,
    users: state.misc.users,
    roles: state.misc.roles,
    shoots: state.shoots.shoots,
    crew: state.crew.crew,
    createdClient: state.users.createdClient,
    createdProducer: state.users.createdProducer,
    equipment: state.misc.equipment,
    companyList: state.clients.companiesList,
    authenticatedUser: state.authentication.authenticatedUser,
    activeCompany: state.companies.activeCompany,
    dialogOpen: state.shoots.showDialog,
    selectedCrewMember: state.crew.selectedCrewMember,
    changeRepresentativeDialogOpen: state.shoots.changeRepresentativeDialog,
    clientList: state.clients.clients,
    recall: state.shoots.recall,
  }
}

const connector = connect(mapStateToProps)

export default withRouter(compose(withStyles(styles))(connector(ShootWrapper)))
